import { render, staticRenderFns } from "./haiyaMails.vue?vue&type=template&id=5b2527fc&scoped=true&"
import script from "./haiyaMails.vue?vue&type=script&lang=js&"
export * from "./haiyaMails.vue?vue&type=script&lang=js&"
import style0 from "./haiyaMails.vue?vue&type=style&index=0&id=5b2527fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2527fc",
  null
  
)

export default component.exports